import {jsx, Text} from "theme-ui";
import React from "react";

const intro = {
    fontWeight: 600,
    fontSize: 2,
    mb: 6
}

const components = {

}

export default components
